import * as React from 'react';
import type { JSX } from 'react';

import faviconPath from '@opendoor/shared-fe/faviconPath';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import ImpersonationBanner from './components/ImpersonationBanner';
import { AtomsAppProvider } from './config/atoms';
import { ToastProvider } from './contexts/ToastContext';
import Routes from './routes';

export default class App extends React.Component {
  public override render(): JSX.Element {
    return (
      <HelmetProvider>
        <AtomsAppProvider>
          <div>
            <Helmet>
              <title>Opendoor</title>
              <meta charSet="utf-8" />
              <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
              <meta name="viewport" content="width=device-width,initial-scale=1,user-scalable=no" />
              <meta name="fragment" content="!" />
              <meta httpEquiv="Accept-CH" content="DPR, Width, Viewport-Width" />
              <link rel="shortcut icon" href={faviconPath()} type="image/png" />
              <link
                rel="apple-touch-icon"
                sizes="144x144"
                href="https://www.opendoor.com/apple-touch-icon-144.png"
              />
            </Helmet>
            <ToastProvider>
              <ImpersonationBanner />
              <Routes />
            </ToastProvider>
          </div>
        </AtomsAppProvider>
      </HelmetProvider>
    );
  }
}
